<template>
  <div>Share</div>
</template>

<script>
export default {
  name: "Share"
};
</script>

<style scoped>

</style>
